import { put, takeLeading } from 'redux-saga/effects';

import { apiErrorHandler, showSuccess, showToastError } from 'utils';

import roomApi from 'api/roomApi';
import {
  // GET ROOM IMAGES
  GET_ROOM_IMAGES,
  GET_ROOM_IMAGES_SUCCESS,
  GET_ROOM_IMAGES_FAILED,

  // ADD IMAGES TO ROOM
  ADD_IMAGES_TO_ROOMS,
  ADD_IMAGES_TO_ROOMS_SUCCESS,
  ADD_IMAGES_TO_ROOMS_FAILED,

  // DELETE ROOM IMAGES
  DELETE_ROOM_IMAGES,
  DELETE_ROOM_IMAGES_SUCCESS,
  DELETE_ROOM_IMAGES_FAILED,

  // CHANGE POSITION ROOM IMAGES
  CHANGE_POSITION_ROOM_IMAGES,
  CHANGE_POSITION_ROOM_IMAGES_SUCCESS,
  CHANGE_POSITION_ROOM_IMAGES_FAILED,

  // GET ROOMS OF PLACE
  GET_ROOMS_OF_PLACE,
  GET_ROOMS_OF_PLACE_SUCCESS,
  GET_ROOMS_OF_PLACE_FAILED,

  // GET ROOM DETAIL OF PLACE
  GET_ROOM_DETAIL_OF_PLACE_SUCCESS,
  GET_ROOM_DETAIL_OF_PLACE_FAILED,
  GET_ROOM_DETAIL_OF_PLACE,

  // CREATE NEW ROOM
  CREATE_NEW_ROOM,
  CREATE_NEW_ROOM_SUCCESS,
  CREATE_NEW_ROOM_FAILED,

  // UPDATE ROOM OF PLACE
  UPDATE_ROOM_OF_PLACE,
  UPDATE_ROOM_OF_PLACE_SUCCESS,
  UPDATE_ROOM_OF_PLACE_FAILED,

  // DELETE ROOM OF PLACE
  DELETE_ROOM_OF_PLACE,
  DELETE_ROOM_OF_PLACE_SUCCESS,
  DELETE_ROOM_OF_PLACE_FAILED,

  // GET ROOM NAMES SETTING
  GET_ROOM_NAMES,
  GET_ROOM_NAMES_SUCCESS,
  GET_ROOM_NAMES_FAILED,

  // SET ROOM PREVIEW IMAGE
  SET_ROOM_PREVIEW_IMAGE,
  SET_ROOM_PREVIEW_IMAGE_SUCCESS,
  SET_ROOM_PREVIEW_IMAGE_FAILED,

  // UPDATE ROOM VIDEO
  UPDATE_ROOM_VIDEO,
  UPDATE_ROOM_VIDEO_SUCCESS,
  UPDATE_ROOM_VIDEO_FAILED,

  // DELETE ROOM VIDEO
  DELETE_ROOM_VIDEO,
  DELETE_ROOM_VIDEO_SUCCESS,
  DELETE_ROOM_VIDEO_FAILED,
} from 'store/room/actionTypes';

function* getRoomImages({ payload }) {
  try {
    const response = yield roomApi.getRoomImages(payload);

    yield put({
      type: GET_ROOM_IMAGES_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_ROOM_IMAGES_FAILED,
    });
  }
}

function* addImagesToRooms({ payload }) {
  try {
    const { placeId, callback } = payload;
    const response = yield roomApi.addImageToRoom(payload);

    yield put({
      type: ADD_IMAGES_TO_ROOMS_SUCCESS,
      payload: response.payload,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
      },
    });

    showSuccess('Thêm ảnh thành công!');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: ADD_IMAGES_TO_ROOMS_FAILED,
    });
  }
}

function* deleteRoomImages({ payload }) {
  const {
    placeId,
    roomIds,
    images,
    callback,
  } = payload;
  try {
    yield roomApi.deleteRoomImages({ placeId, roomIds, images });
    yield put({
      type: DELETE_ROOM_IMAGES_SUCCESS,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
      },
    });

    showSuccess('Xóa hình ảnh thành công');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_ROOM_IMAGES_FAILED,
    });
  }
}

function* changePositionRoomImages({ payload }) {
  try {
    const response = yield roomApi.changePositionRoomImages(payload);

    yield put({
      type: CHANGE_POSITION_ROOM_IMAGES_SUCCESS,
      payload: response.payload,
    });

    showSuccess('Thay đổi thứ tự ảnh thành công');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CHANGE_POSITION_ROOM_IMAGES_FAILED,
    });
    showToastError('Thay đổi thứ tự ảnh không thành công');
  }
}

function* getRoomsOfPlace({ payload }) {
  try {
    const response = yield roomApi.getRoomsOfPlace(payload);

    yield put({
      type: GET_ROOMS_OF_PLACE_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_ROOMS_OF_PLACE_FAILED,
    });
  }
}

function* getRoomDetailOfPlace({ payload }) {
  try {
    const response = yield roomApi.getRoomDetailOfPlace(payload);

    yield put({
      type: GET_ROOM_DETAIL_OF_PLACE_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_ROOM_DETAIL_OF_PLACE_FAILED,
    });
  }
}

function* createNewRoom({ payload: { callback, result } }) {
  try {
    yield roomApi.createNewRoom(result);

    yield put({
      type: CREATE_NEW_ROOM_SUCCESS,
    });

    callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CREATE_NEW_ROOM_FAILED,
    });
  }
}

function* updateRoomOfPlace({ payload: result }) {
  const { result: { placeId, roomId } } = result;
  try {
    yield roomApi.updateRoomOfPlace(result);

    yield put({
      type: UPDATE_ROOM_OF_PLACE_SUCCESS,
    });

    yield put({
      type: GET_ROOM_DETAIL_OF_PLACE,
      payload: {
        placeId,
        roomId,
      },
    });

    showSuccess('Chỉnh sửa phòng thành công!');
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_ROOM_OF_PLACE_FAILED,
    });
  }
}

function* deleteRoomOfPlace({ payload }) {
  const { placeId, roomId, callback } = payload;
  try {
    yield roomApi.deleteRoomOfPlace({ placeId, roomId });

    yield put({
      type: DELETE_ROOM_OF_PLACE_SUCCESS,
    });

    yield put({
      type: GET_ROOMS_OF_PLACE,
      payload: {
        placeId,
      },
    });

    showSuccess('Xóa phòng thành công');

    callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_ROOM_OF_PLACE_FAILED,
    });
  }
}

function* getRoomNamesSetting({ payload }) {
  try {
    const response = yield roomApi.getRoomNamesSetting(payload);

    yield put({
      type: GET_ROOM_NAMES_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_ROOM_NAMES_FAILED,
    });
  }
}

function* setRoomPreviewImage({ payload }) {
  const { placeId, thisRoomId } = payload;
  try {
    yield roomApi.setRoomPreviewImage(payload);

    yield put({
      type: SET_ROOM_PREVIEW_IMAGE_SUCCESS,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
        roomId: thisRoomId,
      },
    });

    showSuccess('Thay đổi ảnh đại diện cho phòng thành công!');
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: SET_ROOM_PREVIEW_IMAGE_FAILED,
    });
  }
}

function* updateRoomVideo({ payload }) {
  try {
    const { placeId, callback } = payload;
    const response = yield roomApi.updateRoomVideo(payload);

    yield put({
      type: UPDATE_ROOM_VIDEO_SUCCESS,
      payload: response.payload,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
      },
    });

    showSuccess('Thêm video thành công!');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_ROOM_VIDEO_FAILED,
    });
  }
}

function* deleteRoomVideo({ payload }) {
  try {
    const { placeId, callback } = payload;

    yield roomApi.deleteRoomVideo(payload);

    yield put({
      type: DELETE_ROOM_VIDEO_SUCCESS,
    });

    yield put({
      type: GET_ROOM_IMAGES,
      payload: {
        placeId,
      },
    });

    showSuccess('Xóa video thành công!');
    callback?.();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_ROOM_VIDEO_FAILED,
    });
  }
}

export default function* locationSaga() {
  yield takeLeading(GET_ROOM_IMAGES, getRoomImages);
  yield takeLeading(ADD_IMAGES_TO_ROOMS, addImagesToRooms);
  yield takeLeading(DELETE_ROOM_IMAGES, deleteRoomImages);
  yield takeLeading(CHANGE_POSITION_ROOM_IMAGES, changePositionRoomImages);
  yield takeLeading(GET_ROOMS_OF_PLACE, getRoomsOfPlace);
  yield takeLeading(GET_ROOM_DETAIL_OF_PLACE, getRoomDetailOfPlace);
  yield takeLeading(CREATE_NEW_ROOM, createNewRoom);
  yield takeLeading(UPDATE_ROOM_OF_PLACE, updateRoomOfPlace);
  yield takeLeading(DELETE_ROOM_OF_PLACE, deleteRoomOfPlace);
  yield takeLeading(GET_ROOM_NAMES, getRoomNamesSetting);
  yield takeLeading(SET_ROOM_PREVIEW_IMAGE, setRoomPreviewImage);
  yield takeLeading(UPDATE_ROOM_VIDEO, updateRoomVideo);
  yield takeLeading(DELETE_ROOM_VIDEO, deleteRoomVideo);
}
